// LanguageSwitcher — a compact <select> dropdown for switching between
// zh-TW and en. Persists via i18next's LanguageDetector cache
// (localStorage key from LANG_STORAGE_KEY).
//
// Two apps share this so we don't drift on look-and-feel. Tailwind classes
// reference @faceheart/ui-tokens colors that both apps load.

import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS, type LangCode } from "./index";

export interface LanguageSwitcherProps {
  // Optional class hook so callers can squeeze the size for a tight header.
  className?: string;
}

export function LanguageSwitcher({ className = "" }: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation("common");
  const current = (i18n.resolvedLanguage ?? i18n.language) as LangCode;

  return (
    <select
      aria-label={t("lang.switcher")}
      value={current}
      onChange={(e) => {
        // i18next persists into localStorage via the detector cache config.
        void i18n.changeLanguage(e.target.value);
      }}
      className={
        "h-9 shrink-0 rounded-lg border border-admin-border bg-admin-bg3 px-3 text-sm text-admin-text1 focus:outline-none focus:border-admin-cyan " +
        className
      }
    >
      {SUPPORTED_LANGS.map((l) => (
        <option key={l.code} value={l.code}>
          {l.label}
        </option>
      ))}
    </select>
  );
}
